import { useCallback, useEffect, useRef, useState } from "react";

const KEY = "routehaul_progress_v1";

function read() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
}

export function useProgress() {
  const [completed, setCompleted] = useState(read);
  const ref = useRef(completed);

  useEffect(() => {
    ref.current = completed;
  }, [completed]);

  useEffect(() => {
    const sync = () => setCompleted(read());
    window.addEventListener("storage", sync);
    window.addEventListener("routehaul-progress", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("routehaul-progress", sync);
    };
  }, []);

  const toggle = useCallback((n) => {
    const prev = ref.current;
    const next = prev.includes(n) ? prev.filter((x) => x !== n) : [...prev, n];
    ref.current = next;
    setCompleted(next);
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("routehaul-progress"));
  }, []);

  const isDone = useCallback((n) => completed.includes(n), [completed]);

  return { completed, toggle, isDone, count: completed.length };
}

export function markStepsComplete(steps) {
  const set = new Set(read());
  steps.forEach((s) => set.add(s));
  localStorage.setItem(KEY, JSON.stringify([...set]));
  window.dispatchEvent(new Event("routehaul-progress"));
}
